import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'modalHead', 'modal')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    margin: '0 0 10px 0',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalHead.tsx